import { Button, Flex, Paper, Text, Title } from "@mantine/core";
import { RetryErrorCardProps } from "../../types";

export function RetryErrorCard({
  title,
  description,
  onRetry,
  retryLabel = "Försök igen",
  children,
}: RetryErrorCardProps) {
  return (
    <Paper p={30} radius={"24px"} mb={"2rem"} role="alert">
      <Flex direction={"column"}>
        <Title order={4} mb={"md"} ff={"var(--wallet-font-family-sambla-sans)"}>
          {title}
        </Title>
        <Text mb={"1rem"}>{description}</Text>
        <Button onClick={onRetry} fullWidth mb={children ? "1rem" : undefined}>
          {retryLabel}
        </Button>
      </Flex>
      {children}
    </Paper>
  );
}
